import Vue from 'vue'
import VueRouter from 'vue-router'
import GoinView from '../views/GoinView.vue'
import ProductsView from '../views/ProductsView.vue'
import InnovationView from '../views/InnovationView.vue'
import BusinessView from '../views/BusinessView.vue'
import NewsView from '../views/NewsView.vue'

import ContactView from '../views/ContactView.vue'
import NewsDetailView from '../views/NewsDetail.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/IndexView.vue')
  },
  {
    path: '/goin',
    name: 'goin',
    component: GoinView
  },
  {
    path: '/products',
    name: 'products',
    component: ProductsView
  },
  {
    path: '/innovation',
    name: 'innovation',
    component: InnovationView
  },
  {
    path: '/business',
    name: 'business',
    component: BusinessView
  },
  {
    path: '/news',
    name: 'news',
    component: NewsView
  },
  {
    path: '/news/:id',
    name: 'newsDetail',
    component: NewsDetailView
  },

  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },
  
]

const router = new VueRouter({
  // mode: 'hash',
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

  // ----------------------------------------------
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router